export class DetailedConditionSearch {
    /**
     * サイト内検索機能
     *
     * @constructor
     * @param {HTMLElement} root - ルートとなる要素
     * @param {Object} options - 設定の変更をする際のオブジェクト
     */
    constructor(root, options) {
        const config = {
            submitButtonSelector: 'button[type="submit"]',
            inputNames: ['category', 'release', 'condition'],
            favoriteInputNames: ['product', 'work', 'artist']
        };

        // ルートとなる要素がない または ルート要素がform要素でない場合は実装しない
        if (!root || root.tagName.toLowerCase() !== 'form') {
            return;
        }

        this.config = Object.assign(config, options);
        this.root = root;
        this.searchItems = this.getSearchItems();
        this.sendUrl = this.root.action;
        this.searchParams = new URLSearchParams();

        this.init();
    }

    /**
     * getSearchItems - name属性ごとのフォーム要素をオブジェクト化する
     * @return {Object} {nameAttribute: [HTMLElement...]}
     */
    getSearchItems() {
        const searchItems = {};

        // name属性の配列が空の場合は空のオブジェクトを返却
        if (!this.config.inputNames.length) {
            return searchItems;
        }

        // name属性ごとに要素を取得
        for (const name of this.config.inputNames) {
            searchItems[name] = Array.from(this.root.elements[name]) || [];
        }

        return searchItems;
    }

    /**
     * createSearchParam - パラメータを生成
     */
    createSearchParam() {
        for (const name of this.config.inputNames) {
            const checkedElementsValues = this.searchItems[name].filter((element) => element.checked).map((element) => element.value);

            if (!checkedElementsValues.length) {
                continue;
            }

            this.searchParams.set(name, checkedElementsValues.join(','));
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.createSearchParam();
        window.location.href = `${this.sendUrl}?${this.searchParams.toString()}`;
    }

    /**
     * init 初期化
     * @return {Void}
     */
    init() {
        this.root.addEventListener('submit', this.handleSubmit.bind(this));
    }
}

/**
 * デフォルト実行処理
 * @return {Viod}
 */
export default () => {
    // グロナビの検索機能
    document.querySelectorAll('.js-search').forEach((element) => new DetailedConditionSearch(element));

    // 検索結果ページの検索機能
    document.querySelectorAll('.js-search-type2').forEach((element) => new DetailedConditionSearch(element, {
        inputNames: ['release', 'condition']
    }));
};
